module.exports = __webpack_public_path__ + "media/images/G-09-2dae569dfdf10f6251f6bd3fb2d2a0d2.svg";